import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import Layout from './components/Layout'
import AnalyticsBeacon from './components/AnalyticsBeacon'
import ConsentBanner from './components/ConsentBanner'
import HomePage from './pages/HomePage'
import ProductPage from './pages/ProductPage'
import SearchPage from './pages/SearchPage'
import NyhederPage from './pages/NyhederPage'
import BatListPage from './pages/BatListPage'
import PrivacyPage from './pages/PrivacyPage'
import AnalyticsAdminPage from './pages/AnalyticsAdminPage'

function App() {
  const location = useLocation()
  if (location.pathname.startsWith('/admin/statistik')) {
    return <AnalyticsAdminPage />
  }

  return (
    <Layout>
      <AnalyticsBeacon />
      <ConsentBanner />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/nyheder" element={<NyhederPage />} />
        <Route path="/bat" element={<BatListPage />} />
        <Route path="/products/:slug" element={<ProductPage />} />
        <Route path="/compare" element={<Navigate to="/bat" replace />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/privatliv" element={<PrivacyPage />} />
      </Routes>
    </Layout>
  )
}

export default App
